import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Schedule a tour banner',
    },
  },
};


export function ScheduleATourHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="scheduleatourhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Schedule a tour banner"
    >
      <InnerPageHeroSubtitle path="scheduleatourhero.subtitle" />
      <RichTextContent
        path="scheduleatourhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="scheduleatourhero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="scheduleatourhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ScheduleATourHero',
  displayName: 'Schedule A Tour Hero',
  tokens: {
    'scheduleatourhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Schedule A Tour</p>',
    },
    'scheduleatourhero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Book a Tour in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'scheduleatourhero.bg_image': bgImageDef,
  },
};

(ScheduleATourHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ScheduleATourHero;
